import React, { useState } from 'react';
import cn from 'classnames';
import { faDownload } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import { Table } from '../../../BrandReports/GraphTypes/Table';
import BarGraph from '../../../BrandReports/GraphTypes/BarGraph';
import Loader from '../../../General/Loader';

import { getBrandReportHeaderLabel } from '../../../../helpers/brand_helpers';

const ConciergeGifting = props => {
  // console.log({ props });
  const { conciergeGifting, title, groupingMethod, downloading } = props;
  const success = !!conciergeGifting?.length;

  const [tab, setTab] = useState('table'); // graph, table
  const download_table = async () => await props.download({ rows: make_table_rows(), fileName: 'concierge_gifting' });
  const download_graph = async () => await props.download({ graph: title });

  const make_table_rows = () => {
    // sent, accepted, rejected, pending

    let sent_running_total = 0;
    const sent_count = {
      key: 'sent_total',
      label: 'Sent',
      description: '(requests sent to brands)',
      values: conciergeGifting.map(result => {
        const { week, month, quarter, sent } = result;
        sent_running_total += parseInt(sent || 0);
        return { label: getBrandReportHeaderLabel({ groupingMethod, week, month, quarter }), value: sent };
      })
    };
    sent_count.values.push({ label: 'Total', value: sent_running_total });

    let accepted_running_total = 0;
    const accepted_count = {
      key: 'accepted_total',
      label: 'Accepted',
      description: '(requests accepted by brands)',
      values: conciergeGifting.map(result => {
        const { week, month, quarter, accepted } = result;
        accepted_running_total += parseInt(accepted || 0);
        return { label: getBrandReportHeaderLabel({ groupingMethod, week, month, quarter }), value: accepted };
      })
    };
    accepted_count.values.push({ label: 'Total', value: accepted_running_total });

    let rejected_running_total = 0;
    const rejected_count = {
      key: 'rejected_total',
      label: 'Rejected',
      description: '(requests rejected by brands)',
      values: conciergeGifting.map(result => {
        const { week, month, quarter, rejected } = result;
        rejected_running_total += parseInt(rejected || 0);
        return { label: getBrandReportHeaderLabel({ groupingMethod, week, month, quarter }), value: rejected };
      })
    };
    rejected_count.values.push({ label: 'Total', value: rejected_running_total });

    let pending_running_total = 0;
    const pending_count = {
      key: 'pending_total',
      label: 'Pending',
      description: '(requests pending by brands)',
      values: conciergeGifting.map(result => {
        const { week, month, quarter, pending } = result;
        pending_running_total += parseInt(pending || 0);
        return { label: getBrandReportHeaderLabel({ groupingMethod, week, month, quarter }), value: pending };
      })
    };
    pending_count.values.push({ label: 'Total', value: pending_running_total });

    return [sent_count, accepted_count, rejected_count, pending_count];
  };

  return (
    <div className='talent-report-card' id={title}>
      {!conciergeGifting ? (
        <Loader />
      ) : (
        <>
          {success && (
            <>
              <div className='header'>
                <div className='description'>
                  <div className='title'>{title}</div>
                  <div className='sub-title'>
                    Gifts are products sent from the brand for the talent to try. These requests can be sent via our platform.
                  </div>
                </div>
                {!downloading && (
                  <div className='talent-report-controls' id={`${title}-card-controls`}>
                    <div className='radio-btns'>
                      <div className={cn('radio-btn', { active: tab === 'graph' })} onClick={() => setTab('graph')}>
                        Graph
                      </div>
                      <div className={cn('radio-btn', { active: tab === 'table' })} onClick={() => setTab('table')}>
                        Table
                      </div>
                    </div>
                    <div className='rounded-button' onClick={() => (tab === 'table' ? download_table() : download_graph())}>
                      {downloading ? (
                        <Loader />
                      ) : (
                        <>
                          <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                          Download
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {tab === 'table' && <Table title='Talent Gifting Requests' data={make_table_rows()} />}
              {tab === 'graph' && (
                <BarGraph
                  title='Gifting Requests Sent'
                  data={conciergeGifting.map(result => {
                    const { week, month, quarter, year, sent } = result;
                    const data = {
                      key: `${week || month || quarter}${year}gifting_requests`,
                      value: sent,
                      label: getBrandReportHeaderLabel({ groupingMethod, week, month, quarter })
                    };
                    return data;
                  })}
                />
              )}
            </>
          )}

          {!success && (
            <>
              <div className='error-centered'>
                <div className='title'>Error Fetching {title}</div>
                <div className='sub-title'>No results.</div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

ConciergeGifting.propTypes = {
  title: PropTypes.string.isRequired,
  conciergeGifting: PropTypes.array,
  groupingMethod: PropTypes.string.isRequired,

  download: PropTypes.func.isRequired,
  downloading: PropTypes.bool.isRequired
};

const ConciergeGiftingConfig = {
  title: 'Gifting Requests'
};

export { ConciergeGifting, ConciergeGiftingConfig };
